import React from 'react';

import styled from 'styled-components/macro';

const Container = styled('div')<any>`
  display: grid;
  grid-template-columns: ${({ isSmallScreen }): string =>
    isSmallScreen ? '1fr 1fr' : '1fr 1fr 1fr'};
  justify-items: start;
  gap: ${({ isLargeScreen }): string => (isLargeScreen ? '2em' : '1em')};

  & > a:nth-child(3n-1) {
    justify-self: center;
  }
  & > a:nth-child(3n) {
    justify-self: end;
  }
`;

interface IResourcesWrapper {
  isLargeScreen: boolean;
  isSmallScreen: boolean;
}

const ResourcesWrapper: React.FC<IResourcesWrapper> = ({
  children,
  isLargeScreen,
  isSmallScreen,
}) => {
  return (
    <Container isSmallScreen={isSmallScreen} isLargeScreen={isLargeScreen}>
      {children}
    </Container>
  );
};

export default ResourcesWrapper;
